import { AuthGuard } from '@app/core/auth/guards/auth.guard';
import { IsDesktopGuard } from '@app/core/auth/guards/isDesktop.guard';
import { RoleGuard } from '@app/core/auth/guards/role.guard';
import { MyRocheGuard } from '@core/auth/guards/myRoche.guard';
import { FreezeBlockGuard } from '@core/auth/guards/freeze-block.guard';

export const GUARDS = [
  AuthGuard,
  RoleGuard,
  IsDesktopGuard,
  MyRocheGuard,
  FreezeBlockGuard
];
